module.exports = __webpack_public_path__ + "img/nolans.9da044b4.jpg";